function prevencao(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Evite aglomerações e sempre utilize máscara em locais públicos,  higienize as mãos frequentemente com água e sabão ou com álcool 70%.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Caso apresente sintomas, isole-se imediatamente, por 14 dias. Se estiver doente, também é necessário seguir medidas de prevenção dentro de sua residência.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Prevenção domiciliar: não compartilhe utensílios ou objetos pessoais; manter as janelas abertas para circulação do ar e distância mínima de 1,5 metros dos demais moradores.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"A identificação de pessoas contaminadas com o vírus SARS-CoV-2 é uma importante forma de diminuir a transmissão da doença. O diagnóstico pode ser clínico e/ou laboratorial.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"O diagnóstico clínico é realizado pela análise dos sintomas, exames radiológicos e confirmados (ou não) pelos exames laboratoriais.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Os exames laboratoriais detectam a presença do material genético do vírus (RNA viral), chamado RT-PCR, no qual são analisadas amostras da secreção nasal ou da orofaringe.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Os testes rápidos, atualmente existem duas modalidades,  um que detecta   fragmentos de moléculas do vírus e outro que detecta anticorpos no sangue.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Nestes casos, são analisadas  amostras da secreção nasal ou da orofaringe, ou sangue onde os anticorpos são pesquisados.",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					},
					{
						"text":"Os anticorpos (tipo IgG)  são detectados no sangue depois de 2 a 3 semanas do início da infecção, porém o teste apresenta altos índices de resultados falsos (negativos ou positivos).",
						"title":"Como se prevenir?",
						"image":"images/games/informs/prevencao/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/prevencao/1.png"
			}
		]
	};
}

export {prevencao};
